import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { OrderNoteFragmentDoc } from '../../fragments/__generated__/OrderNote.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteOrderMutationVariables = Types.Exact<{
  token?: Types.InputMaybe<Types.Scalars['String']['input']>;
  pk?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type DeleteOrderMutation = { deleteOrder: { errors: Array<string> } };

export type TransferOrderToCheckoutMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
  cartType: Types.CartTypeEnum;
}>;


export type TransferOrderToCheckoutMutation = { transferOrderToCheckout: { errors: Array<string> } };

export type AttachOrderToUserMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type AttachOrderToUserMutation = { attachOrderToUser: { errors: Array<string> } };

export type DuplicateOrderMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type DuplicateOrderMutation = { duplicateOrder: { errors: Array<string> } };

export type OpenOrderCartMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type OpenOrderCartMutation = { openOrderCart: { errors: Array<string> } };

export type EditOrderMutationVariables = Types.Exact<{
  orderId: Types.Scalars['Int']['input'];
  isDraft: Types.Scalars['Boolean']['input'];
}>;


export type EditOrderMutation = { editOrder: { errors: Array<string>, order: { id: string, pk: number, token: string } | null } };

export type CreateOrderNoteMutationVariables = Types.Exact<{
  input: Types.OrderNoteInput;
}>;


export type CreateOrderNoteMutation = { createOrderNote: { errors: Array<string>, note: { id: string, pk: number, content: string, isPublic: boolean, date: any, creator: string, replyToMe: boolean } | null } };

export type OrderCreatePaymentMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
  paymentMethodId: Types.Scalars['Int']['input'];
}>;


export type OrderCreatePaymentMutation = { orderCreatePayment: { errors: Array<string>, url: string | null, token: string | null, paymentToken: string | null, paymentVariant: Types.PaymentVariantEnum | null, extraData: any | null, order: { id: string, token: string, totalNet: { currency: string, gross: number } | null } | null } };


export const DeleteOrderDocument = gql`
    mutation DeleteOrder($token: String, $pk: Int) {
  deleteOrder(token: $token, pk: $pk) {
    errors
  }
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      token: // value for 'token'
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const TransferOrderToCheckoutDocument = gql`
    mutation TransferOrderToCheckout($token: String!, $cartType: CartTypeEnum!) {
  transferOrderToCheckout(token: $token, cartType: $cartType) {
    errors
  }
}
    `;
export type TransferOrderToCheckoutMutationFn = Apollo.MutationFunction<TransferOrderToCheckoutMutation, TransferOrderToCheckoutMutationVariables>;

/**
 * __useTransferOrderToCheckoutMutation__
 *
 * To run a mutation, you first call `useTransferOrderToCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferOrderToCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferOrderToCheckoutMutation, { data, loading, error }] = useTransferOrderToCheckoutMutation({
 *   variables: {
 *      token: // value for 'token'
 *      cartType: // value for 'cartType'
 *   },
 * });
 */
export function useTransferOrderToCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<TransferOrderToCheckoutMutation, TransferOrderToCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferOrderToCheckoutMutation, TransferOrderToCheckoutMutationVariables>(TransferOrderToCheckoutDocument, options);
      }
export type TransferOrderToCheckoutMutationHookResult = ReturnType<typeof useTransferOrderToCheckoutMutation>;
export type TransferOrderToCheckoutMutationResult = Apollo.MutationResult<TransferOrderToCheckoutMutation>;
export type TransferOrderToCheckoutMutationOptions = Apollo.BaseMutationOptions<TransferOrderToCheckoutMutation, TransferOrderToCheckoutMutationVariables>;
export const AttachOrderToUserDocument = gql`
    mutation AttachOrderToUser($token: String!) {
  attachOrderToUser(token: $token) {
    errors
  }
}
    `;
export type AttachOrderToUserMutationFn = Apollo.MutationFunction<AttachOrderToUserMutation, AttachOrderToUserMutationVariables>;

/**
 * __useAttachOrderToUserMutation__
 *
 * To run a mutation, you first call `useAttachOrderToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachOrderToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachOrderToUserMutation, { data, loading, error }] = useAttachOrderToUserMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAttachOrderToUserMutation(baseOptions?: Apollo.MutationHookOptions<AttachOrderToUserMutation, AttachOrderToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachOrderToUserMutation, AttachOrderToUserMutationVariables>(AttachOrderToUserDocument, options);
      }
export type AttachOrderToUserMutationHookResult = ReturnType<typeof useAttachOrderToUserMutation>;
export type AttachOrderToUserMutationResult = Apollo.MutationResult<AttachOrderToUserMutation>;
export type AttachOrderToUserMutationOptions = Apollo.BaseMutationOptions<AttachOrderToUserMutation, AttachOrderToUserMutationVariables>;
export const DuplicateOrderDocument = gql`
    mutation DuplicateOrder($token: String!) {
  duplicateOrder(token: $token) {
    errors
  }
}
    `;
export type DuplicateOrderMutationFn = Apollo.MutationFunction<DuplicateOrderMutation, DuplicateOrderMutationVariables>;

/**
 * __useDuplicateOrderMutation__
 *
 * To run a mutation, you first call `useDuplicateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOrderMutation, { data, loading, error }] = useDuplicateOrderMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDuplicateOrderMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateOrderMutation, DuplicateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateOrderMutation, DuplicateOrderMutationVariables>(DuplicateOrderDocument, options);
      }
export type DuplicateOrderMutationHookResult = ReturnType<typeof useDuplicateOrderMutation>;
export type DuplicateOrderMutationResult = Apollo.MutationResult<DuplicateOrderMutation>;
export type DuplicateOrderMutationOptions = Apollo.BaseMutationOptions<DuplicateOrderMutation, DuplicateOrderMutationVariables>;
export const OpenOrderCartMutationDocument = gql`
    mutation OpenOrderCartMutation($token: String!) {
  openOrderCart(token: $token) {
    errors
  }
}
    `;
export type OpenOrderCartMutationMutationFn = Apollo.MutationFunction<OpenOrderCartMutation, OpenOrderCartMutationVariables>;

/**
 * __useOpenOrderCartMutation__
 *
 * To run a mutation, you first call `useOpenOrderCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenOrderCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openOrderCartMutation, { data, loading, error }] = useOpenOrderCartMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useOpenOrderCartMutation(baseOptions?: Apollo.MutationHookOptions<OpenOrderCartMutation, OpenOrderCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenOrderCartMutation, OpenOrderCartMutationVariables>(OpenOrderCartMutationDocument, options);
      }
export type OpenOrderCartMutationHookResult = ReturnType<typeof useOpenOrderCartMutation>;
export type OpenOrderCartMutationMutationResult = Apollo.MutationResult<OpenOrderCartMutation>;
export type OpenOrderCartMutationMutationOptions = Apollo.BaseMutationOptions<OpenOrderCartMutation, OpenOrderCartMutationVariables>;
export const EditOrderMutationDocument = gql`
    mutation EditOrderMutation($orderId: Int!, $isDraft: Boolean!) {
  editOrder(orderId: $orderId, isDraft: $isDraft) {
    errors
    order {
      id
      pk
      token
    }
  }
}
    `;
export type EditOrderMutationMutationFn = Apollo.MutationFunction<EditOrderMutation, EditOrderMutationVariables>;

/**
 * __useEditOrderMutation__
 *
 * To run a mutation, you first call `useEditOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrderMutation, { data, loading, error }] = useEditOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      isDraft: // value for 'isDraft'
 *   },
 * });
 */
export function useEditOrderMutation(baseOptions?: Apollo.MutationHookOptions<EditOrderMutation, EditOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrderMutation, EditOrderMutationVariables>(EditOrderMutationDocument, options);
      }
export type EditOrderMutationHookResult = ReturnType<typeof useEditOrderMutation>;
export type EditOrderMutationMutationResult = Apollo.MutationResult<EditOrderMutation>;
export type EditOrderMutationMutationOptions = Apollo.BaseMutationOptions<EditOrderMutation, EditOrderMutationVariables>;
export const CreateOrderNoteMutationDocument = gql`
    mutation CreateOrderNoteMutation($input: OrderNoteInput!) {
  createOrderNote(input: $input) {
    errors
    note {
      ...OrderNoteFragment
    }
  }
}
    ${OrderNoteFragmentDoc}`;
export type CreateOrderNoteMutationMutationFn = Apollo.MutationFunction<CreateOrderNoteMutation, CreateOrderNoteMutationVariables>;

/**
 * __useCreateOrderNoteMutation__
 *
 * To run a mutation, you first call `useCreateOrderNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderNoteMutation, { data, loading, error }] = useCreateOrderNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderNoteMutation, CreateOrderNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderNoteMutation, CreateOrderNoteMutationVariables>(CreateOrderNoteMutationDocument, options);
      }
export type CreateOrderNoteMutationHookResult = ReturnType<typeof useCreateOrderNoteMutation>;
export type CreateOrderNoteMutationMutationResult = Apollo.MutationResult<CreateOrderNoteMutation>;
export type CreateOrderNoteMutationMutationOptions = Apollo.BaseMutationOptions<CreateOrderNoteMutation, CreateOrderNoteMutationVariables>;
export const OrderCreatePaymentDocument = gql`
    mutation OrderCreatePayment($token: String!, $paymentMethodId: Int!) {
  orderCreatePayment(token: $token, paymentMethodId: $paymentMethodId) {
    errors
    url
    token
    paymentToken
    paymentVariant
    extraData
    order {
      id
      token
      totalNet {
        currency
        gross
      }
    }
  }
}
    `;
export type OrderCreatePaymentMutationFn = Apollo.MutationFunction<OrderCreatePaymentMutation, OrderCreatePaymentMutationVariables>;

/**
 * __useOrderCreatePaymentMutation__
 *
 * To run a mutation, you first call `useOrderCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCreatePaymentMutation, { data, loading, error }] = useOrderCreatePaymentMutation({
 *   variables: {
 *      token: // value for 'token'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useOrderCreatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<OrderCreatePaymentMutation, OrderCreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderCreatePaymentMutation, OrderCreatePaymentMutationVariables>(OrderCreatePaymentDocument, options);
      }
export type OrderCreatePaymentMutationHookResult = ReturnType<typeof useOrderCreatePaymentMutation>;
export type OrderCreatePaymentMutationResult = Apollo.MutationResult<OrderCreatePaymentMutation>;
export type OrderCreatePaymentMutationOptions = Apollo.BaseMutationOptions<OrderCreatePaymentMutation, OrderCreatePaymentMutationVariables>;